import { render, staticRenderFns } from "./PassageSubQuestionAnswer.vue?vue&type=template&id=9980ac6c&scoped=true&"
import script from "./PassageSubQuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./PassageSubQuestionAnswer.vue?vue&type=script&lang=js&"
import style0 from "./PassageSubQuestionAnswer.vue?vue&type=style&index=0&id=9980ac6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9980ac6c",
  null
  
)

export default component.exports